import { forwardRef } from 'react'
import { NavLink } from 'react-router-dom'
import { AiOutlineHome } from '@react-icons/all-files/ai/AiOutlineHome'

import { ReactComponent as IconCrude } from './icons/oil-barrel.svg'
import { ReactComponent as IconProduct } from './icons/oil-industry.svg'
import { ReactComponent as IconPetrochemical } from './icons/lab-tool.svg'
import { ReactComponent as IconChartering } from './icons/ship1.svg'
import { ReactComponent as IconDerivatives } from './icons/chart.svg'
import { ReactComponent as IconMarketAnalysis } from './icons/analysis.svg'

const MobileMenu = forwardRef(({ handleClose }, ref) => {
	return (
		<div
			className="mobile-submenu border-b-8 border-ci5 left-0 absolute top-full w-full z-20"
			ref={ref}
		>
			<NavLink className="item" to="/home">
				<AiOutlineHome size={22} />
				<span className="ml-3">Home</span>
			</NavLink>
			<NavLink className="item" to="/crude">
				<IconCrude height={22} width={22} />
				<span className="ml-3">Crude</span>
			</NavLink>
			<NavLink className="item" to="/products">
				<IconProduct height={22} width={22} />
				<span className="ml-3">Products</span>
			</NavLink>
			<NavLink className="item" to="/petrochemical">
				<IconPetrochemical height={22} width={22} />
				<span className="ml-3">Petrochemical</span>
			</NavLink>
			<NavLink className="item" to="/chartering">
				<IconChartering height={22} width={22} />
				<span className="ml-3">Chartering</span>
			</NavLink>
			<NavLink className="item" to="/derivatives">
				<IconDerivatives height={22} width={22} />
				<span className="ml-3">Derivatives</span>
			</NavLink>
			<NavLink className="item" to="/market-analysis">
				<IconMarketAnalysis height={22} width={22} />
				<span className="ml-3">Market Analysis</span>
			</NavLink>
		</div>
	)
})

export default MobileMenu
